const MediaSizeType = Object.freeze({
  DEFAULT: "DEFAULT",
  LETTER: "LETTER",
  POSTER: "POSTER",
  NON_STANDARD: "NON_STANDARD"
});
export default MediaSizeType;